import type { InstitutionApplicationStatus } from '@hublo/enums'

export type WorkerInstitutionInfo = {
  institution: InstitutionInfo
  joinRequestStatus?: number
  workerStatus: number
  serviceName?: string
  poleName?: string
  isDesactivatedInstitution: boolean
  registrationNumber?: string
  applicationStatus: InstitutionApplicationStatus
  missingMandatoryDocuments: string[]
  deletedReasonMessage: string | null
}

export type InstitutionInfo = {
  id: number
  name?: string
  address?: string
  phone?: string
  presentation?: string
  accessInfo?: string
}

export type WorkerInstitutionJob = {
  jobStatus: number
  jobName: string
}

export enum HublerInstitutionSlotAvailabilitiesState {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  NONE = 'NONE',
}

export type HublerInstitutionSlotAvailabilitiesPeriod = {
  idPeriod: string
  labelKey: 'day' | 'night' | 'morning' | 'afternoon' | 'evening'
  start: string
  end: string
  state: HublerInstitutionSlotAvailabilitiesState
}
export type HublerInstitutionSlotAvailabilitiesPeriods = {
  periods: HublerInstitutionSlotAvailabilitiesPeriod[]
}
export type HublerInstitutionSlotAvailabilities = {
  timePreferences: HublerInstitutionSlotAvailabilitiesPeriods
}

export type WorkerInstitutionService = {
  id: number
  name: string
}
